import { Mapper } from "../../../../base/utils/mapper";
import { ConvenioModel } from "../../../../domain/models/configuration/convenio.model";
import { ConvenioEntity } from "../entities/convenio.entity";

export class ConvenioImplementationRepositoryMapper extends Mapper<ConvenioEntity, ConvenioModel> {
	mapFrom(param: ConvenioEntity): ConvenioModel {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		};
	}
	mapTo(param: ConvenioModel): ConvenioEntity {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		}
	}
}